import { createContext } from "react";

export const AppContext = createContext();

export const AppContextProvider = ({ config, children }) => (
  <AppContext.Provider value={config}>{children}</AppContext.Provider>
);

